module.exports = __webpack_public_path__ + "static/media/384.c79ba7ab.png";